import { useMutation } from '@apollo/client';

import {
  GQLDExperiment,
  GQLGbxUpgradeMutation,
  GQLMutationgbxUpgradeArgs,
  Maybe,
} from '../../../../../gql.generated';
import UPGRADE_GBX from '../../mutations/UPGRADE_GBX';

const useAddGbxSub = (dExperiment?: GQLDExperiment, wg?: boolean) => {
  return useMutation<
    {
      gbxUpgrade?: Maybe<GQLGbxUpgradeMutation>;
    },
    GQLMutationgbxUpgradeArgs
  >(UPGRADE_GBX, {
    variables: {
      dExperiment,
      wg,
    },
  });
};

export default useAddGbxSub;
